import { render } from "./ProfileView.vue?vue&type=template&id=3b4b46aa&scoped=true&ts=true"
import script from "./ProfileView.vue?vue&type=script&lang=ts"
export * from "./ProfileView.vue?vue&type=script&lang=ts"

import "./ProfileView.vue?vue&type=style&index=0&id=3b4b46aa&lang=scss&scoped=true"

import exportComponent from "/Users/rboss/repos/TRENZ/Kunden/KaRa/Mockup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4b46aa"]])

export default __exports__